import store from "@/store";

const addresses = {
  ...store.state.netWorkConfig.swapConfig,
  jackRouterV2: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
  jackFactoryV2: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73',
};

export const getAddress = address => {
  return address;
};

export const getJackFactoryAddress = () => {
  return getAddress(addresses.jackFactory);
};

export const getJackRouterAddress = () => {
  return getAddress(addresses.jackRouter);
};

export const getJackFactoryAddressV2 = () => {
  return getAddress(addresses.jackFactoryV2);
};

export const getJackRouterAddressV2 = () => {
  return getAddress(addresses.jackRouterV2);
};

export const getWethAddress = () => {
  return getAddress(addresses.weth);
};
